import { Checkbox, IconButton, Menu, MenuItem, styled, TextField, Typography, useTheme } from "@mui/material";
import { StyledAutocomplete, StyledInputBase as BaseInput, StyledSelect } from "components/Input/styled";
import { Field, useFormikContext } from "formik";

import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import dayjs, { Dayjs } from "dayjs";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import shortid from "shortid";
import { MouseEvent, useState } from "react";
import { Calendar } from "react-datepicker2";
import CalendarIcon from "assets/icons/CalendarIcon";
import { formatDate } from "helpers";

const StyledInputBase = styled(BaseInput)(({ theme }) => ({
  width: "100%",
  height: "40px",
}));
const InputContainer = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
}));

export const TextInput = ({
  name,
  label,
  required,
  disabled,
  value,
  inputType,
  helperText,
  isPassword,
  onClick,
}: {
  name: string;
  inputType?: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  value?: string;
  isPassword?: boolean;
  helperText?: string;
  onClick?: () => void;
}) => {
  const theme = useTheme();
  return (
    <InputContainer>
      <Typography fontWeight="bold" variant="body2" sx={{ marginBottom: "5px" }}>
        {label}&nbsp;{required ? "*" : ""}
      </Typography>
      <Field
        type={isPassword ? "password" : inputType || "text"}
        name={name}
        as={StyledInputBase}
        disabled={disabled}
        placeholder={label}
        onClick={onClick}
        autoComplete="off"
      />
      {helperText && (
        <Typography color={theme.palette.disabled.main} variant="caption" sx={{ marginTop: "5px" }}>
          {helperText}
        </Typography>
      )}
    </InputContainer>
  );
};

type optionType = {
  value: string | boolean | number | any;
  label: string;
};

export const RadioInput = ({
  radioOption,
  label,
  name,
  disabled,
}: {
  radioOption: optionType[];
  label?: string;
  name: string;
  disabled: boolean;
}) => {
  const formikContext = useFormikContext();

  const { values }: any = formikContext;
  return (
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label">{label}</FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue={radioOption[0].value}
        sx={{ display: "flex", flexDirection: "row" }}
        name="radio-buttons-group"
        onChange={(event) => {
          formikContext.setFieldValue(name, event.currentTarget.value);
          // @ts-ignore
        }}
        value={values[name]}
      >
        {radioOption.map((item, key) => (
          <FormControlLabel
            value={item.value}
            key={key}
            control={<Radio disabled={disabled} />}
            label={item.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export function AutoComplete({
  name,
  label,
  required,
  selectOption,
  fullHeight,
}: {
  name: string;
  label?: string;
  required?: boolean;
  selectOption: optionType[];
  fullHeight?: any;
}) {
  const formikContext = useFormikContext();

  //@ts-ignore
  const initialValue = formikContext?.values[name];

  return (
    <InputContainer>
      {label && (
        <Typography fontWeight="bold" variant="body2" sx={{ marginBottom: "5px" }}>
          {label}&nbsp;{required ? "*" : ""}
        </Typography>
      )}
      <StyledAutocomplete
        fullHeight
        disablePortal
        id="combo-box-demo"
        //   @ts-ignore
        options={selectOption}
        //   @ts-ignore
        onChange={(event: any, newValue: any) => {
          if (newValue) {
            formikContext.setFieldValue(name, newValue.value);
            if (name === "typeId") {
              formikContext.setFieldValue("type", newValue.type);
            }
          }
        }}
        defaultValue={selectOption.find((item) => item.value === initialValue)}
        sx={{ width: 300 }}
        // @ts-ignore
        renderInput={(params) => (
          <TextField
            placeholder="انتخاب کنید"
            {...params}
            //   label="Movie"
          />
        )}
      />
    </InputContainer>
  );
}

export const SelectInput = ({
  name,
  label,
  required,
  helperText,
  selectOption,
  disabled,
  onChange,
  placeholder,
}: {
  name: string;
  label: string;
  placeholder?: string;
  required?: boolean;
  helperText?: string;
  selectOption?: optionType[];
  disabled?: boolean;
  onChange?: object;
}) => {
  const theme = useTheme();
  const formikContext: any = useFormikContext();

  //@ts-ignore
  const initialValue = formikContext?.values[name];

  //@ts-ignore
  const onSelect = (event, options) => {
    const value = options.props.value;
    if (onChange) {
      //@ts-ignore
      onChange(value, name);
    } else {
      formikContext.setFieldValue(name, value);
    }
  };

  const options =
    //@ts-ignore
    typeof selectOption === "function" ? selectOption(formikContext.values.state) : selectOption ?? [];

  return (
    <InputContainer>
      {label !== "" && (
        <Typography fontWeight="bold" variant="body2" sx={{ marginBottom: "5px" }}>
          {label}&nbsp;{required ? "*" : ""}
        </Typography>
      )}
      {initialValue && (
        <Field
          onChange={onSelect}
          disabled={disabled}
          key={10}
          name={name}
          as={StyledSelect}
          placeholder={placeholder || label}
          // @ts-ignore
          value={initialValue}
        >
          {
            // @ts-ignore
            options.map((item) => {
              //@ts-ignore
              return (
                <MenuItem style={{ justifyContent: "end" }} key={shortid.generate()} value={item.value}>
                  {item.label}
                </MenuItem>
              );
            })
          }
        </Field>
      )}
      {!initialValue && (
        <Field
          onChange={onSelect}
          disabled={disabled}
          key={5}
          name={name}
          as={StyledSelect}
          placeholder={label}
          // @ts-ignore
          value={initialValue}
        >
          {
            // @ts-ignore
            options.map((item) => {
              //@ts-ignore
              return (
                <MenuItem
                  style={{ justifyContent: "end" }}
                  key={shortid.generate()}
                  value={item.value}
                  selected={true}
                >
                  {item.label}
                </MenuItem>
              );
            })
          }
        </Field>
      )}
      {helperText && (
        <Typography color={theme.palette.disabled.main} variant="caption" sx={{ marginTop: "5px" }}>
          {helperText}
        </Typography>
      )}
    </InputContainer>
  );
};

const CheckboxContainer = styled("div")(({ theme }) => ({
  display: "flex",
  height: "40px",
  alignItems: "center",
}));

export const CheckboxInput = ({
  name,
  label,
  disabled,
  checked,
}: {
  name: string | number;
  label: string;
  disabled?: boolean;
  checked?: boolean;
}) => {
  const formikContext = useFormikContext();
  const { values }: any = formikContext;
  return (
    <CheckboxContainer>
      <Checkbox
        disabled={disabled}
        value={!!+values[name]}
        onChange={(event) => {
          formikContext.setFieldValue(`${name}`, !+values[name]);
        }}
        checked={checked !== undefined ? checked : !!+values[name]}
      />
      <Typography sx={{ marginRight: "10px" }} variant="body2">
        {label}
      </Typography>
    </CheckboxContainer>
  );
};
const InputWrapper = styled("div")(({ theme }) => ({
  padding: "2px 4px",
  border: `solid 2px #e6e6e6`,
  display: "flex",
  borderRadius: 4,
  alignItems: "center",
  justifyContent: "space-between",
  height: "40px",
  width: "100%",
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  width: "100%",
  ".MuiInputBase-root": {
    borderColor: "#e6e6e6",
    borderRadius: "4px",
    borderWidth: "2px",
    borderStyle: "solid",
    height: "40px",
  },
  "& fieldset": {
    border: "none !important",
  },
}));

export const TimeInput = ({ name, label, required }: { name: string; label: string; required?: boolean }) => {
  const [value, setValue] = useState<Dayjs | null>(dayjs("2014-08-18T21:11:54"));

  const handleChange = (newValue: Dayjs | null) => {
    setValue(newValue);
  };
  return (
    <InputContainer>
      <Typography fontWeight="bold" variant="body2" sx={{ marginBottom: "5px" }}>
        {label}&nbsp;{required ? "*" : ""}
      </Typography>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          value={value}
          onChange={handleChange}
          // @ts-ignore
          renderInput={(params) => <StyledTextField {...params} />}
        />
      </LocalizationProvider>
    </InputContainer>
  );
};
export const CalendarInput = ({
  name,
  label,
  isGregorian,
  disabled,
  required,
}: {
  name: string;
  label: string;
  required?: boolean;
  disabled?: boolean;
  isGregorian?: boolean;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    !disabled && setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const formikContext = useFormikContext();
  const { values } = formikContext;

  return (
    <InputContainer>
      <Typography fontWeight="bold" variant="body2" sx={{ marginBottom: "5px" }}>
        {label}&nbsp;{required ? "*" : ""}
      </Typography>
      <InputWrapper>
        <Typography variant="body2">
          {/* @ts-ignore */}
          {values[name]}
        </Typography>
        <IconButton onClick={handleClick}>
          <CalendarIcon />
        </IconButton>
      </InputWrapper>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        sx={{
          "& div": {
            "& ul": {
              paddingTop: 0,
              paddingBottom: 0,
            },
          },
        }}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Calendar
          isGregorian={String(isGregorian) === "true"}
          onChange={(date) => {
            formikContext.setFieldValue(name, formatDate(date, isGregorian));
            handleClose();
          }}
        />
      </Menu>
    </InputContainer>
  );
};
